import "./fixed-top.css";
import { FixedTop } from "./fixed-top";
export default FixedTop;